import { render } from "./NewsItemView.vue?vue&type=template&id=a950346c&scoped=true"
import script from "./NewsItemView.vue?vue&type=script&lang=js"
export * from "./NewsItemView.vue?vue&type=script&lang=js"

import "./NewsItemView.vue?vue&type=style&index=0&id=a950346c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a950346c"]])

export default __exports__